
const sectionContent = document.querySelectorAll( '.main__wrap > .statistics > .is-style-section-title-link' );    
if (sectionContent) {
    sectionContent.forEach(cta => {
        cta.parentElement.classList.add( 'statistics-with-cta' );
    });        
}
// check if statistic block has content and remove if no content added. This is used on Event posts where the default template includes a statistics block.
const sectionTitle = document.querySelectorAll( '.main__wrap .statistics .section__title' );    

if(sectionTitle.length == 0 || sectionTitle[0].innerHTML == "") {
    const statistics = document.querySelector('.statistics');
    if(statistics) {
         statistics.remove();
    }
       
}

	

